var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medical",
    clipPath: "url(#clip0_1232_23550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.65308 2.04902C5.24312 1.94848 5.8482 1.98165 6.42372 2.14606C6.99924 2.31048 7.53052 2.60196 7.97841 2.99902L8.00308 3.02102L8.02574 3.00102C8.45321 2.62588 8.95576 2.34621 9.49986 2.18067C10.044 2.01513 10.6171 1.96752 11.1811 2.04102L11.3451 2.06502C12.0559 2.18776 12.7204 2.50045 13.2681 2.97C13.8157 3.43954 14.2262 4.04845 14.456 4.73224C14.6859 5.41603 14.7265 6.14925 14.5737 6.85426C14.4208 7.55927 14.0801 8.20982 13.5877 8.73702L13.4677 8.86035L13.4357 8.88768L8.46908 13.807C8.35446 13.9205 8.20261 13.9885 8.04167 13.9986C7.88072 14.0086 7.72158 13.96 7.59374 13.8617L7.53108 13.807L2.53574 8.85902C2.00656 8.34412 1.63021 7.6928 1.44838 6.97719C1.26656 6.26159 1.28634 5.50961 1.50556 4.80456C1.72477 4.0995 2.13485 3.46888 2.69038 2.98253C3.24592 2.49618 3.92523 2.17308 4.65308 2.04902Z",
    fill: "#FFA7A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCondition);
export default __webpack_public_path__ + "static/media/medical-condition.499e2152f53890d68242b40357a2a4f3.svg";
export { ForwardRef as ReactComponent };